import React from "react"

const Facebook = () => (
	<svg
		width="24"
		height="24"
		xmlns="http://www.w3.org/2000/svg"
		className="inline-block fill-current align-middle">
		<path
			d="M8.625 22V11.999H6.526V8.553h2.1v-2.07C8.625 3.674 9.81 2 13.177 2h2.803v3.447h-1.752c-1.311 0-1.398.482-1.398 1.38l-.006 1.726H16l-.372 3.446h-2.803V22h-4.2z"
			fillRule="evenodd"
		/>
	</svg>
)

export default Facebook
